import EthereumService from '@/services/ethereum'
import { SHA256 } from '@/utils/hash'
import cookie from '@/utils/cookie'
export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.route = options.route
    this.kulapApi = options.kulapApi
  }
  async updateUserProfile () {
    if (cookie.get('accessToken') && cookie.get('user')) {
      const { data } = await this.kulapApi.getUserProfile()
      this.store.dispatch('setUser', data)
    } else {
      this.store.dispatch('setUser', {})
    }
  }

  async registerNewUserViaEmail (form, recaptchaToken) {
    const password = SHA256.hex(form.password)
    let data = {
      ...form,
      password,
      displayName: form.displayName || form.email,
      recaptchaToken
    }
    const referralCode = cookie.get('ref')
    if (referralCode) data.referralCode = referralCode
    if (data.confirmPassword) {
      delete data.confirmPassword
    }
    const { data: result } = await this.kulapApi.postRegisterNewUser(data)
    cookie.set('accessToken', result.access_token)
    cookie.set('user', result.user)
    await this.updateUserProfile()
  }

  async signInWithFacebook (uid, accessToken) {
    let data = { uid, accessToken }
    const referralCode = cookie.get('ref')
    if (referralCode) data.referralCode = referralCode
    const { data: result } = await this.kulapApi.postLoginWithFacebook(data)
    if (result && result.user && !result.secretKeyForVerify2FA) { // not required 2fa
      await this.setUserAuthCookies(result)
    }
    return result
  }

  async signInWithGoogle (googleUser) {
    const { id_token: googleIdToken } = await googleUser.getAuthResponse()
    let data = { googleIdToken }
    const referralCode = cookie.get('ref')
    if (referralCode) data.referralCode = referralCode
    const { data: result } = await this.kulapApi.postLoginWithGoogle(data)
    if (result && result.user && !result.secretKeyForVerify2FA) { // not required 2fa
      await this.setUserAuthCookies(result)
    }
    return result
  }
  async verify2FACode (code, secretKeyForVerify2FA, userId) {
    const { data } = await this.kulapApi.getVerify2FA(code, secretKeyForVerify2FA, userId)
    return data
  }
  async setUserAuthCookies (data) {
    cookie.set('accessToken', data.access_token)
    cookie.set('user', data.user)
    await this.updateUserProfile()
  }
  setReferralCode () {
    const refCode = this.route.query.ref
    if (!cookie.get('ref') && refCode) {
      cookie.setWithExpireTime('ref', refCode, 24) // Referral code expire in 24 hrs.
    }
  }
  async updateUserEmail (email, recaptchaToken) {
    const data = { email, recaptchaToken }
    const { data: result } = await this.kulapApi.updateUserEmail(data)
    return result
  }
}



// WEBPACK FOOTER //
// ./src/pages/Register/service.js